import React from 'react';
import { fmtMoney, fmtDate } from '../lib/utils';
import PrintHeader, { DEFAULT_COMPANY } from './PrintHeader';

const BLUE = '#1E3A8A';

export default function LedgerPrint({ ledger, company }) {
  const c = { ...DEFAULT_COMPANY, ...(company || {}) };
  const cust = ledger.customer;
  return (
    <div className="bg-white text-slate-900 font-sans p-4" style={{ minWidth: 640 }}>
      <PrintHeader company={c} />

      <div className="flex items-center justify-between my-5" style={{ color: BLUE }}>
        <div className="text-sm w-44">
          <p className="font-semibold">Statement Date</p>
          <p className="num text-[15px] mt-1" dir="ltr">{fmtDate(new Date().toISOString().slice(0, 10))}</p>
        </div>
        <div className="px-8 py-2 rounded-full border-2 text-center whitespace-nowrap" style={{ borderColor: BLUE }}>
          <span className="font-arabic text-2xl leading-none align-middle" dir="rtl" style={{ unicodeBidi: 'isolate' }}>كشف حساب</span>
          <span className="mx-3 opacity-40">·</span>
          <span className="font-heading font-bold text-base uppercase tracking-wide align-middle">Ledger</span>
        </div>
        <div className="text-sm w-44 text-right">
          <p className="font-semibold">Outstanding</p>
          <p className={`num font-bold text-base mt-1 ${ledger.balance > 0 ? 'text-red-600' : 'text-emerald-600'}`} data-testid="ledger-balance">{fmtMoney(ledger.balance, c.currency)}</p>
        </div>
      </div>

      <div className="mb-5 text-[15px]" style={{ color: BLUE }}>
        <span className="font-semibold text-sm">Customer / <span className="font-arabic" style={{ unicodeBidi: 'isolate' }}>العميل</span>:</span>{' '}
        <span className="font-bold text-slate-900 border-b border-dotted border-slate-400 px-2 text-[18px]">{cust.companyName}</span>
        {cust.contactPerson && <span className="text-sm text-slate-500 ml-2">{cust.contactPerson}</span>}
        {cust.phone && <span className="text-sm text-slate-500 ml-2 num" dir="ltr">{cust.phone}</span>}
      </div>

      <table className="w-full mb-6 border" style={{ borderColor: BLUE }}>
        <thead>
          <tr className="text-white text-left" style={{ backgroundColor: BLUE }}>
            <th className="px-3 py-2.5 text-sm font-semibold w-28">Date</th>
            <th className="px-3 py-2.5 text-sm font-semibold">Description / <span className="font-arabic">البيان</span></th>
            <th className="px-3 py-2.5 text-sm font-semibold text-right w-32">Debit</th>
            <th className="px-3 py-2.5 text-sm font-semibold text-right w-32">Credit</th>
            <th className="px-3 py-2.5 text-sm font-semibold text-right w-32">Balance</th>
          </tr>
        </thead>
        <tbody>
          {ledger.entries.map((e, i) => (
            <tr key={i} className={i % 2 ? 'bg-[#FDF4F6]' : ''} style={{ borderTop: '1px solid #dbe3f5' }} data-testid="ledger-entry-row">
              <td className="px-3 py-2.5 text-sm num whitespace-nowrap">{fmtDate(e.date)}</td>
              <td className="px-3 py-2.5 text-[15px] font-medium">{e.description}</td>
              <td className="px-3 py-2.5 text-right num text-[15px] whitespace-nowrap">{e.debit ? fmtMoney(e.debit, c.currency) : '—'}</td>
              <td className="px-3 py-2.5 text-right num text-[15px] whitespace-nowrap text-emerald-700">{e.credit ? fmtMoney(e.credit, c.currency) : '—'}</td>
              <td className="px-3 py-2.5 text-right num text-[15px] font-semibold whitespace-nowrap">{fmtMoney(e.balance, c.currency)}</td>
            </tr>
          ))}
          <tr className="border-t-2 font-bold" style={{ borderColor: BLUE }}>
            <td className="px-3 py-2.5 text-[15px]" colSpan="2">Totals · <span className="font-arabic">الإجمالي</span></td>
            <td className="px-3 py-2.5 text-right num text-[15px] whitespace-nowrap">{fmtMoney(ledger.totalDebit, c.currency)}</td>
            <td className="px-3 py-2.5 text-right num text-[15px] text-emerald-700 whitespace-nowrap">{fmtMoney(ledger.totalCredit, c.currency)}</td>
            <td className={`px-3 py-2.5 text-right num text-[16px] ${ledger.balance > 0 ? 'text-red-600' : 'text-emerald-700'}`}>{fmtMoney(ledger.balance, c.currency)}</td>
          </tr>
        </tbody>
      </table>
      {!ledger.entries.length && <p className="text-center text-slate-400 text-sm mb-6">No transactions for this customer yet.</p>}

      <div className="flex justify-between items-end mt-10 text-sm" style={{ color: BLUE }}>
        <div className="text-center">
          <div className="border-t border-dotted border-slate-400 w-56 mb-1.5" />
          <p>Customer's Signature · <span className="font-arabic text-base">توقيع العميل</span></p>
        </div>
        <div className="text-center">
          <div className="border-t border-dotted border-slate-400 w-56 mb-1.5" />
          <p>For {c.name} · <span className="font-arabic text-base">التوقيع</span></p>
        </div>
      </div>
    </div>
  );
}
